import {
    Loader,
    accordionClick,
    mosViewMore,
    viewMore,
    saveStudent,
    saveGHContent } from './front.js';
import {
    tabMenuScroll,
    doTabMenuClick,
    setTabPanels } from './components/tabpanels-tabs.js';
window.Loader = Loader;
window.accordionClick = accordionClick;
window.viewMore = viewMore;
window.mosViewMore = mosViewMore;
window.saveStudent = saveStudent;
window.saveGHContent = saveGHContent;
window.tabMenuScroll = tabMenuScroll;
window.doTabMenuClick = doTabMenuClick;
window.setTabPanels = setTabPanels;

document.addEventListener("DOMContentLoaded", setTabPanels);
